<template>
  <ts-loading-banner :loading="loading">
    <div class="ts-relative">
      <gmap-map
        :center="center"
        :zoom="12"
        style="width: 100%; height: 80vh;"
        @click="onMapClick"
      >
        <gmap-polygon
          ref="polygon"
          :draggable="editable"
          :paths="paths"
          :editable="editable"
          @paths_changed="updateEdited($event)"
          @rightclick="handleClickForDelete"
        >
        </gmap-polygon>
      </gmap-map>
      <div
        class="ts-bg-transparent ts-absolute ts-right-0 ts-top-0 ts-w-32 ts-space-y-1 ts-mt-16 ts-mr-2 ts-justify-end"
      >
        <button
          v-if="!isCreateNew"
          class="ts-rounded ts-text-white ts-uppercase ts-font-robot ts-px-2 ts-py-1 ts-border-2 ts-border-white ts-whitespace-no-wrap ts-w-full ts-text-xs"
          style="background-color: #00B97C; opacity: 90%;"
          @click="onClickNewDraw"
        >
          New Drawing
        </button>
        <button
          v-else
          class="ts-rounded ts-text-white ts-uppercase ts-font-robot ts-px-2 ts-py-1 ts-border-2 ts-border-white ts-whitespace-no-wrap ts-w-full ts-text-xs"
          style="background-color: #00B97C; opacity: 90%;"
          @click="onCancelDrawing"
        >
          Cancel Drawing
        </button>
        <button
          class="ts-rounded ts-text-white ts-uppercase ts-font-robot ts-px-2 ts-py-1 ts-border-2 ts-border-white ts-w-full ts-text-xs"
          style="background-color: #00B97C; opacity: 90%;"
          @click="() => (editable = !editable)"
        >
          Edit
        </button>
        <button
          class="ts-rounded ts-text-white ts-uppercase ts-font-robot ts-px-2 ts-py-1 ts-border-2 ts-border-white ts-w-full ts-text-xs"
          style="background-color: #00B97C; opacity: 90%;"
          @click="store"
        >
          Update
        </button>
      </div>
    </div>
  </ts-loading-banner>
</template>

<script>
export default {
  name: 'drawingGeofence',
  props: ['record'],
  data() {
    return {
      center: { lng: 105.57359185298843, lat: 12.291513194851614 },
      editable: false,
      isCreateNew: false,
      editPath: [],
      paths: [],
      loading: false,
      oldData: []
    }
  },
  created() {
    this.setPath()
  },
  methods: {
    store() {
      this.loading = true
      this.$store
        .dispatch('corporate/address/updateCommune', {
          code: this.record.commune_code,
          data: {
            paths: this.editPath.length > 0 ? this.editPath : this.paths
          }
        })
        .then(() => {
          this.loading = false
          this.$emit('cancel')
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    updateEdited(mvcArray) {
      let paths = []
      for (let i = 0; i < mvcArray.getLength(); i++) {
        let path = []
        for (let j = 0; j < mvcArray.getAt(i).getLength(); j++) {
          let point = mvcArray.getAt(i).getAt(j)
          path.push({ lat: point.lat(), lng: point.lng() })
        }
        paths.push(path)
      }
      this.editPath = paths[0]
    },
    setPath() {
      let polygon = this.record.coordinates
      polygon = polygon
        .replace('POLYGON(', '')
        .replace('(', '')
        .replace('))', '')

      polygon = polygon.split(',').map(latLng => {
        return {
          lat: parseFloat(latLng.split(' ')[1]),
          lng: parseFloat(latLng.split(' ')[0])
        }
      })

      if (polygon.length > 0) {
        this.center.lng = polygon[0].lng
        this.center.lat = polygon[0].lat
        this.paths = polygon
      }
    },
    handleClickForDelete($event) {
      if ($event.vertex) {
        this.$refs.polygon.$polygonObject
          .getPaths()
          .getAt($event.path)
          .removeAt($event.vertex)
        console.log($event.vertex)
        this.paths.slice($event.vertex, 1)
      }
    },
    onClickNewDraw() {
      this.oldData = this.paths
      this.isCreateNew = true
      this.editable = true
      this.paths = []
      this.editPath = []
    },
    onCancelDrawing() {
      this.isCreateNew = false
      this.editable = false
      this.paths = this.oldData
      this.editPath = []
    },
    onMapClick(data) {
      if (this.isCreateNew) {
        const lat = data.latLng.lat().toFixed(6)
        const lng = data.latLng.lng().toFixed(6)
        this.editPath.push({
          lat: parseFloat(lat),
          lng: parseFloat(lng)
        })
        this.paths = this.editPath
      }
    }
  }
}
</script>
